import * as React from 'react';
import { ITabItemProps } from './tab-types';
import { TabContext } from './tab-context';

export function TabItem(props: ITabItemProps) {
    const { addItem, removeItem } = React.useContext(TabContext);

    React.useEffect(() => addItem({ ...props, id: props.id }), [addItem, props]);

    React.useEffect(() => () => removeItem(props.id), [props.id, removeItem]);

    return null;
}
